import { render, staticRenderFns } from "./InventoryManagement.vue?vue&type=template&id=34eef10a&scoped=true"
import script from "./InventoryManagement.vue?vue&type=script&lang=js"
export * from "./InventoryManagement.vue?vue&type=script&lang=js"
import style0 from "./InventoryManagement.vue?vue&type=style&index=0&id=34eef10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eef10a",
  null
  
)

export default component.exports